import { render, staticRenderFns } from "./AccountTransactionDetails.vue?vue&type=template&id=5da2c89f"
import script from "./AccountTransactionDetails.vue?vue&type=script&lang=js"
export * from "./AccountTransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountTransactionDetails.vue?vue&type=style&index=0&id=5da2c89f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports